var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{class:`banner-${_setup.props.columnType}-container`},_vm._l((_setup.props?.bannerList),function(item,index){return (_setup.props?.bannerList)?_c(_setup.MultiJumpContainer,{key:index,class:[`banner-${_vm.columnType}`],attrs:{"imgUrl":item.imgUrl,"biTag":item._id,"jumpInfo":{
        jumpUrl: item.jumpUrl,
        appid: item.appid,
        username: item.username,
        path:item.jumpUrl,
      }}}):_vm._e()}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }